export default "__VITE_PUBLIC_ASSET__31bf25b5__"